import { html } from './template';

export function markText(text: string, textToMark: string) {
  if (textToMark.length === 0) {
    return text;
  }
  const index = text.toLowerCase().indexOf(textToMark.toLowerCase());
  if (index === -1) {
    return text;
  }
  return html`${text.substr(0, index)}<mark>${text.substr(
    index,
    textToMark.length
  )}</mark>${text.substr(index + textToMark.length)}`;
}
